$(document).ready(function () {
    const tabs = $('.es-tab-group .tab');

    // Helper function to extract a unique storage key for this specific student page
    function getStorageKey() {
        return `active_tab_${window.location.pathname}`;
    }

    // Helper function to save tab with a 24-hour expiration
    function setCachedTab(tabId) {
        const data = {
            tabId: tabId,
            expiry: new Date().getTime() + (24 * 60 * 60 * 1000)
        };
        localStorage.setItem(getStorageKey(), JSON.stringify(data));
    }

    // Helper function to get cached tab if it hasn't expired
    function getCachedTab() {
        const cached = localStorage.getItem(getStorageKey());
        if (!cached) return null;

        const data = JSON.parse(cached);
        if (new Date().getTime() > data.expiry) {
            localStorage.removeItem(getStorageKey());
            return null;
        }
        return data.tabId;
    }

    // --- Tab Click Handler ---
    tabs.click(function (e) {
        const selectedTab = $(e.currentTarget);
        const tabList = selectedTab.closest('.tab-list');
        const groupTabs = tabList.children('.tab');

        const selectedTabPanel = tabList.siblings(`.tab-panel[aria-labelledby="${selectedTab.attr('id')}"]`);
        const allTabPanels = tabList.siblings('.tab-panel');
        const tabId = selectedTab.attr('id');

        groupTabs.attr('aria-selected', false);
        selectedTab.attr('aria-selected', true);
        groupTabs.attr('tabindex', -1);
        selectedTab.attr('tabindex', 0);

        allTabPanels.removeClass('open');
        selectedTabPanel.addClass('open'); // Opens the panel

        if (tabId) {
            setCachedTab(tabId);
            history.replaceState(null, null, `#${tabId}`);
        }
    });

    // --- Tab Keyboard Navigation ---
    tabs.keydown(function (e) {
        const currentTab = $(e.target);
        const firstTab = currentTab.parent().children('.tab:first-child');
        const lastTab = currentTab.parent().children('.tab:last-child');
        let previousTab = currentTab.prev();
        let nextTab = currentTab.next();

        if (previousTab.length === 0) previousTab = lastTab;
        if (nextTab.length === 0) nextTab = firstTab;

        switch (e.key) {
            case 'ArrowLeft':
            case 'ArrowUp':
                previousTab.focus();
                break;
            case 'ArrowRight':
            case 'ArrowDown':
                nextTab.focus();
                break;
            case 'Home':
                firstTab.focus();
                break;
            case 'End':
                lastTab.focus();
                break;
            default:
                break;
        }
    });

    // --- Tab Group Initialization & Activation Logic ---
    const tabGroups = $('.es-tab-group');
    tabGroups.each(function () {
        const tabList = $(this).children('.tab-list');
        $(this).children('.tab').detach().appendTo(tabList);
        const urlHash = window.location.hash;
        const cachedTabId = getCachedTab();

        let openTab = $();

        // Priority Selection
        if (urlHash && tabList.children(urlHash).length > 0) {
            openTab = tabList.children(urlHash);
        } else if (cachedTabId && tabList.children(`#${cachedTabId}`).length > 0) {
            openTab = tabList.children(`#${cachedTabId}`);
        } else {
            openTab = tabList.children('.tab[aria-selected="true"]:first');
        }

        if (openTab.length === 0) {
            openTab = tabList.children('.tab:first');
        }

        openTab.click();
    });

    tabGroups.show();
});

// --- In-page Anchor Tab Links ---
$(document).on('click', '.tab-linker', function (e) {
    e.preventDefault();

    const targetHash = $(this).attr('href');
    const targetTab = $(targetHash);

    if (targetTab.length > 0) {
        history.pushState(null, null, targetHash);
        targetTab.trigger('click');
        $('html, body').animate({
            scrollTop: targetTab.closest('.es-tab-group').offset().top - 20
        }, 300);
    }
});
